// src/pages/Dashboard.js
import React, { useContext } from "react";
import AdminLayout from "../components/AdminLayout";
import { AuthContext } from "../contexts/AuthContext";
import { Tabs, Tab } from "react-bootstrap";
import DashboardCartasInfo from "./DashboardCartasInfo";
import DashboardEstoqueInfo from "./DashboardEstoqueInfo";

function Dashboard() {
  const { user } = useContext(AuthContext);

  // Define o header do dashboard (usado em usuários não-admin)
  const dashboardHeader = (
    <div className="page-header d-print-none" style={{ marginTop: "0px", paddingBottom: "18px" }}>
      <div className="row align-items-center">
        <div className="col">
          <h2 className="page-title">Dashboard</h2>
          <div className="text-muted mt-1">Resumo das atividades</div>
        </div>
      </div>
    </div>
  );

  // Define apenas o body (page-body) com os widgets do dashboard
  const dashboardBody = (
    <>
      {/* First Set of Widgets (Large Cards) */}
      <div className="row row-deck row-cards" style={{ marginTop: "0px", paddingBottom: "8px" }}>
        {/* Widget: Visitas */}
        <div className="col-sm-6 col-lg-3">
          <div className="card">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="subheader">Visitas</div>
                <div className="ms-auto lh-1">
                  <div className="dropdown">
                    <a
                      className="dropdown-toggle text-secondary"
                      href="#"
                      data-bs-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Últimos 7 dias
                    </a>
                    <div className="dropdown-menu dropdown-menu-end">
                      <a className="dropdown-item active" href="#">Últimos 7 dias</a>
                      <a className="dropdown-item" href="#">Últimos 30 dias</a>
                      <a className="dropdown-item" href="#">Últimos 3 meses</a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="h1 mb-3">33</div>
              <div className="text-secondary">12 pendentes</div>
            </div>
          </div>
        </div>

        {/* Widget: Monitoramento */}
        <div className="col-sm-6 col-lg-3">
          <div className="card">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="subheader">Monitoramento</div>
                <div className="ms-auto lh-1">
                  <div className="dropdown">
                    <a
                      className="dropdown-toggle text-secondary"
                      href="#"
                      data-bs-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Últimos 7 dias
                    </a>
                    <div className="dropdown-menu dropdown-menu-end">
                      <a className="dropdown-item active" href="#">Últimos 7 dias</a>
                      <a className="dropdown-item" href="#">Últimos 30 dias</a>
                      <a className="dropdown-item" href="#">Últimos 3 meses</a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="h1 mb-3">132</div>
              <div className="text-secondary">40 pendentes</div>
            </div>
          </div>
        </div>

        {/* Widget: Pedidos */}
        <div className="col-sm-6 col-lg-3">
          <div className="card">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="subheader">Pedidos</div>
                <div className="ms-auto lh-1">
                  <div className="dropdown">
                    <a
                      className="dropdown-toggle text-secondary"
                      href="#"
                      data-bs-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Últimos 7 dias
                    </a>
                    <div className="dropdown-menu dropdown-menu-end">
                      <a className="dropdown-item active" href="#">Últimos 7 dias</a>
                      <a className="dropdown-item" href="#">Últimos 30 dias</a>
                      <a className="dropdown-item" href="#">Últimos 3 meses</a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="h1 mb-3">78</div>
              <div className="text-secondary">32 atendidos</div>
            </div>
          </div>
        </div>

        {/* Widget: Instituições */}
        <div className="col-sm-6 col-lg-3">
          <div className="card">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="subheader">Instituições</div>
                <div className="ms-auto lh-1">
                  <div className="dropdown">
                    <a
                      className="dropdown-toggle text-secondary"
                      href="#"
                      data-bs-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Edital 001/2025
                    </a>
                    <div className="dropdown-menu dropdown-menu-end">
                      <a className="dropdown-item active" href="#">Edital 001/2025</a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="h1 mb-3">117</div>
              <div className="text-secondary">10 gestores</div>
            </div>
          </div>
        </div>
      </div>

      {/* Second Set of Widgets (Small Cards) */}
      <div className="row row-cards">
        {/* Widget: Visitas */}
        <div className="col-sm-6 col-lg-3">
          <div className="card card-sm">
            <div className="card-body">
              <div className="row align-items-center">
                <div className="col-auto">
                  <span className="bg-primary text-white avatar">
                    {/* SVG omitido para brevidade */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
                      <path d="M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z" />
                    </svg>
                  </span>
                </div>
                <div className="col">
                  <div className="font-weight-medium">132 Visitas Realizadas</div>
                  <div className="text-secondary">64 agendadas</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Widget: Relatórios */}
        <div className="col-sm-6 col-lg-3">
          <div className="card card-sm">
            <div className="card-body">
              <div className="row align-items-center">
                <div className="col-auto">
                  <span className="bg-green text-white avatar">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2" />
                      <path d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" />
                      <path d="M9 14h.01" />
                      <path d="M9 17h.01" />
                      <path d="M12 16l1 1l3 -3" />
                    </svg>
                  </span>
                </div>
                <div className="col">
                  <div className="font-weight-medium">78 Relatórios</div>
                  <div className="text-secondary">24 aguardando visita</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Widget: Pedidos */}
        <div className="col-sm-6 col-lg-3">
          <div className="card card-sm">
            <div className="card-body">
              <div className="row align-items-center">
                <div className="col-auto">
                  <span className="bg-red text-white avatar">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M3 8m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z" />
                      <path d="M12 8l0 13" />
                      <path d="M19 12v7a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-7" />
                      <path d="M7.5 8a2.5 2.5 0 0 1 0 -5a4.8 8 0 0 1 4.5 5a4.8 8 0 0 1 4.5 -5a2.5 2.5 0 0 1 0 5" />
                    </svg>
                  </span>
                </div>
                <div className="col">
                  <div className="font-weight-medium">623 Pedidos</div>
                  <div className="text-secondary">16 hoje</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Widget: Gestores */}
        <div className="col-sm-6 col-lg-3">
          <div className="card card-sm">
            <div className="card-body">
              <div className="row align-items-center">
                <div className="col-auto">
                  <span className="bg-facebook text-white avatar">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" />
                      <path d="M6 21v-2a4 4 0 0 1 4 -4h2.5" />
                      <path d="M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z" />
                      <path d="M19 18v.01" />
                    </svg>
                  </span>
                </div>
                <div className="col">
                  <div className="font-weight-medium">3 Gestores in loco</div>
                  <div className="text-secondary">+4 hoje</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );

  const originalDashboard = (
    <>
      {dashboardHeader}
      {dashboardBody}
    </>
  );

  return (
    <AdminLayout>
      <Tabs
        defaultActiveKey={
          user.groups.includes("admin")
            ? "geral"
            : user.groups.includes("cartas")
            ? "cartas"
            : "estoque"
        }
        id="admin-dashboard-tabs"
        className="mb-3"
      >
        {user.groups.includes("admin") && (
          <Tab eventKey="geral" title="Geral">
            {dashboardBody}
          </Tab>
        )}
        {(user.groups.includes("admin") || user.groups.includes("cartasvisitas")) && (
          <Tab eventKey="cartas" title="Cartas">
            <DashboardCartasInfo />
          </Tab>
        )}
        {(user.groups.includes("admin") || user.groups.includes("estoque") || user.groups.includes("estoque_ver") || user.groups.includes("estoque_admin")) && (
          <Tab eventKey="estoque" title="Estoque">
            <DashboardEstoqueInfo />
          </Tab>
        )}
      </Tabs>
    </AdminLayout>
  );
}

export default Dashboard;